/**
 * @ngdoc run
 * @memberof mercury.services.analytics
 * @name AnalyticsRunner
 * @description A run block that defines an analytics module that will observe
 *   navigation events and handle page view tracking with Google Analytics.
 */
angular.module('mercury.services.analytics')
.run(["$rootScope", "$window", "logger", function analyticsRun($rootScope, $window, logger) {

  if (!$window.gtag) {
    logger.info('Not initialising analytics, window.gtag not present');
    return;
  }

  var BASE_PATH = '#/';

  function getHash(url) {
    // Ideally we'd use `(new URL(url)).hash` and avoid doing this manually but
    // there are still some users on Internet Explorer and this does the job.
    var hashRegex = /^[^#]*#/;
    return hashRegex.test(url) ?
      url.replace(hashRegex, '#') :
      '';
  }

  function getAppPath(hash) {
    // We use the location hash as the app path, removing any parameters as these
    // will constantly be different but ultimately don't mean it's a different
    // page the user is on. We also standardise to the base path when the hash
    // has no trailing slash (occurs during login)
    return hash.replace(/\?.*$/, '').replace(/^#$/, BASE_PATH);
  }

  function trackPageView(appPath) {
    // if appPath is the base path we ignore it, this will ultimately be
    // redirected immediately to the dashboard page which we want to track as
    // the first view after login
    if (appPath === BASE_PATH) {
      return;
    }
    gtag('event', 'page_view', {
      'page_title': $window.document.title,
      'page_location': appPath
    });
  }

  // Listener for router location changes, when these are heard we determine if
  // a full route change has occured (not just url parameters), and if so a
  // page view event is sent to the analytics platform.
  $rootScope.$on('$locationChangeStart', function(ev, next, current) {
    var currentAppPath = getAppPath(getHash(current));
    var nextAppPath = getAppPath(getHash(next));

    if (currentAppPath === nextAppPath) {
      // When the cleansed path (i.e. without params) hasn't changed then we
      // don't send a page view - this happens during login where url params
      // change but not the base url
      return;
    }

    trackPageView(nextAppPath);
  });

  // Track a page view immediately on page load, necessary to avoid the
  // current/next condition in the event listener above excluding the initial
  // page load due to there being no difference between them.
  trackPageView(
    getAppPath($window.location.hash)
  );

}]);
